module.exports = __webpack_public_path__ + "0af558f90e884c1fef31115c60f76a15.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/main/img/name-male-2.svg
// module id = 88
// module chunks = 0